import { repeatTask } from 'shared/utils/promise';
import { loadYmapsApi } from 'shared/utils/ymaps';
import { isScriptError } from './isScriptError';
import { IApplicationContext } from 'shared/types/applicationContext';
import { ESuggestType } from '@cian/geosuggest-widget';

interface IParams {
  request: string;
  options?: YMaps.ISuggestOptions;
}

export async function suggest(
  { logger }: IApplicationContext,
  { request, options }: IParams,
): Promise<YMaps.ISuggestResult<ESuggestType.geo>[]> {
  try {
    return await repeatTask(3, () =>
      loadYmapsApi({ require: ['suggest'] })
        .then(ymaps => ymaps.suggest<ESuggestType.geo>(request, options))
        .then(items => {
          if (isScriptError(items)) {
            throw new Error(items.message);
          }

          return items || [];
        }),
    );
  } catch (ex) {
    logger.warning(ex, { domain: 'suggest', initiator: 'loadYmapsApi' });

    return [];
  }
}
